import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('dependentForm', 'documents-delete', [
  'DELETE_SUCCESS',
]);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'dependent_registration',
  type: 'delete',
  slug: [
    'assignments',
    {
      type: 'payload',
      selector: ['id'],
    },
    'documents',
    {
      type: 'payload',
      selector: ['docId'],
    },
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/dependentForm/documents-delete-req.js